export function ArrowIcon() {
	return <svg width='10' height='8' viewBox='0 0 10 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M5.25981 7.55C5.14434 7.75 4.85566 7.75 4.74019 7.55L0.92968 0.95C0.81421 0.75 0.958547 0.5 1.18949 0.5L8.81051 0.5C9.04145 0.5 9.18579 0.75 9.07032 0.95L5.25981 7.55Z'
			fill='#888'/>
	</svg>;
}
